import type { AssetRef, LandingPage, PageContainer } from "#gen/bundles/v1/bundle_pb.js";
import type { Mode } from "#gen/bundles/v1/service_pb.js";
import type { BackgroundPaint } from "#lib/components/flow/viewer/utils.js";
import type { BundleDag, BundleNode } from "#lib/dag.js";
import type { Snippet } from "svelte";

export type ColorMode = "RGB" | "CMYK";

export interface LayoutSlots {
	share?: Snippet;
	conversion?: Snippet;
	section1?: Snippet;
	section2?: Snippet;
	apps?: Snippet;
	app?: Snippet<[number]>;
	divider?: Snippet;
	footer?: Snippet<[Mode]>;
}

export interface LayoutEvents {
	onShow?: (node: BundleNode<AssetRef>) => void;
	onMore?: () => void;
	onShare?: () => void;
	onMenu?: () => void;
}

export interface LayoutProps<T = LandingPage | PageContainer> extends LayoutSlots, LayoutEvents {
	key: string;
	dag: BundleDag<AssetRef>;
	container: T;
	mode: Mode;
	readOnly: boolean;
	numApps?: number;
	isLightBackground?: boolean;
	modal?: boolean;
	// Set by the container. Defaults to inline so a host that omits it is unaffected.
	backgroundPaint?: BackgroundPaint;
	style?: string;
	hasPrimaryConversion?: boolean;
	shouldPromoteFirstApp?: boolean;
	accessory?: Record<string, Snippet | undefined>;
}

export function isLegacyLayout(name: string | undefined): boolean {
	return !name || name === "legacy";
}

export function isBasicLayout(name: string | undefined): boolean {
	return isLegacyLayout(name) || name === "blank";
}
